import react from "react";

import NorthFace1 from "../images/commercials/NFAdult/01THENORTHFACEADULT Large.jpeg";
import NorthFace2 from "../images/commercials/NFAdult/02THENORTHFACEADULT Large.jpeg";
import NorthFace3 from "../images/commercials/NFAdult/03THENORTHFACEADULT Large.jpeg";
import NorthFace4 from "../images/commercials/NFAdult/04THENORTHFACEADULT Large.jpeg";

const NorthFace = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={NorthFace1} alt="North Face Adult - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={NorthFace2} alt="North Face Adult - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={NorthFace3} alt="North Face Adult - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={NorthFace4} alt="North Face Adult - Image 4"/>
                </div>
            </div>
        </div>
    );
}

export default NorthFace;